<template>
  <div class="bg bg10">
    <div class="class--con">
      <class-but @forward="forward"/>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";


export default {
  name: "studyBlessing",
  components: {ClassBut},
  data() {
    return {

    }
  },
  methods: {
    forward() {
      //成果展示
      this.$router.push({
        name: 'PageEighth',
        query: this.$route.query,
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import "reportClass.less";
</style>
